import client from "@/services/lukita/client";
import { MutationError, QueryError } from "./errors";
import factory from "./errors/factory";
import { getHeaders } from "./utils";

const execute = async (
  fetcher,
  StandardError,
  query,
  variables,
  context = {},
) => {
  const { data, error } = await fetcher(query, variables, {
    fetchOptions: {
      headers: await getHeaders(),
    },
    ...context,
    ...(context?.cache === false && {
      requestPolicy: "network-only",
    }),
  });

  if (error) return factory(StandardError, error);
  return data;
};

export const query = async (query, variables, context) =>
  execute(client.query, QueryError, query, variables, context);

export const mutation = (mutation, variables, context) =>
  execute(client.mutation, MutationError, mutation, variables, context);
